import React, { useContext } from 'react';
import {
  Grid,
  Autocomplete,
  TextField,
  Checkbox,
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { titleize } from "inflection";
import { ProjectContext } from '../../../Contexts/Project/Context';
import ContentNotFound from "./ContentNotFound";
import { useQuery } from '@apollo/client/react';
import { GetCompanyTagsDocument } from '@/graphql/generated/graphql';
import { arrayLength } from '@/utils/helperFunctions';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ProjectTags: React.FC = () => {
  const { project, onTagsChange } = useContext(ProjectContext);
  const selectedTags = project.tagIds || [];
  const { data, loading } = useQuery(GetCompanyTagsDocument);

  if (!loading && arrayLength(data?.getCompanyTags) === 0) return (
    <ContentNotFound
      title="No tags found"
      subtitle="To add tags to a project, please add them via Company Settings."
    />
  );

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Autocomplete
          multiple
          disableCloseOnSelect
          id="project-tags-selector"
          loading={loading}
          options={data?.getCompanyTags || []}
          value={data?.getCompanyTags?.filter(tag => selectedTags.includes(tag.id)) || []}
          onChange={(_, newValue) => {
            onTagsChange(newValue.map(tag => tag.id));
          }}
          getOptionLabel={(option) => titleize(option.title)}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={`selectedTags-${option.id}`}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {titleize(option.title)}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Project Tags (Optional)"
              placeholder="Select tags"
            />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
      </Grid>
    </Grid>
  );
};

export default ProjectTags;
